import React from 'react';
import { ReactComponent as FavoriteIcon } from '@assets/images/app/favorite-icon.svg';
import { ReactComponent as FavoritedIcon } from '@assets/images/app/favorited-icon.svg';
import { ReactComponent as ShareIcon } from '@assets/images/app/share-icon.svg';

export interface ProductActionButtonsProps {
  productId?: string;
  productTitle?: string;
  favoritedCount?: number;
  isFavorited?: boolean;
  onShare?: () => void;
  onFavoriteToggle?: () => void;
  onLoginRequired?: () => void;
  canUseButton?: boolean;
  setCanUseButton?: (value: boolean) => void;
  className?: string;
  style?: React.CSSProperties;
}

export const ProductActionButtons: React.FC<ProductActionButtonsProps> = ({
  favoritedCount = 0,
  isFavorited = false,
  onShare,
  onFavoriteToggle,
  canUseButton = true,
  setCanUseButton,
  className,
  style,
}) => {
  const handleShare = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onShare?.();
  };

  const handleFavoriteToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!canUseButton) {
      return;
    }

    if (setCanUseButton) {
      setCanUseButton(false);
      setTimeout(() => {
        setCanUseButton(true);
      }, 3000);
    }

    onFavoriteToggle?.();
  };

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        borderTop: '1px solid #EFF1F4',
        ...style,
      }}>
      <button
        className="link-button"
        style={{
          height: '60px',
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={handleShare}>
        <ShareIcon />
        <span
          style={{
            marginLeft: '4px',
            color: 'var(--Neutral-100, #242424)',
            textAlign: 'right',
            fontFamily: 'Pretendard',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 500,
          }}>
          공유
        </span>
      </button>
      <div style={{ width: '1px', height: '20px', backgroundColor: '#EFF1F4', flexShrink: 0 }}></div>
      <button
        className="link-button"
        style={{
          height: '60px',
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={handleFavoriteToggle}>
        {isFavorited ? <FavoritedIcon /> : <FavoriteIcon />}
        <span
          style={{
            marginLeft: '4px',
            color: 'var(--Neutral-100, #242424)',
            textAlign: 'right',
            fontFamily: 'Pretendard',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 500,
          }}>
          찜
        </span>
        {favoritedCount > 0 && (
          <span
            style={{
              marginLeft: '4px',
              color: 'var(--Primary-95, #FF3D8F)',
              textAlign: 'right',
              fontFamily: 'Pretendard',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 400,
            }}>
            {favoritedCount}
          </span>
        )}
      </button>
    </div>
  );
};
